import '@emotion/jest'

declare global {
  const PACKAGE_VERSION: string
}

export {}
